<template>
  <div
    v-if="renderHeader"
    ref="header"
    class="bcc-header card-header"
  >
    <slot name="header" />
  </div>
  <div
    v-else-if="renderCustomHeader"
    ref="header"
    class="bcc-header card-header"
  >
    <h5
      class="card-title"
      data-eq-part="headline"
    >
      <span v-if="title">{{ title }}</span>
      <slot
        v-else-if="titleSlot"
        name="title"
      />
    </h5>
    <div
      v-if="actionsSlot"
      class="form-actions"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  useSlots, inject, Ref, ref, computed,
} from 'vue';

const props = defineProps<{
  title?: string;
  hasExpansionComponent?: boolean;
}>();

const fontSize = inject('fontSize') as Ref<string>;
const fontWeight = inject('fontWeight') as Ref<string>;

const {
  header: headerSlot,
  actions: actionsSlot,
  title: titleSlot,
} = useSlots();

const renderHeader = ref(!props.hasExpansionComponent && !!headerSlot?.());
const renderCustomHeader = ref(!props.hasExpansionComponent && (!!props.title || !!actionsSlot?.() || !!titleSlot?.()));

const header = ref<HTMLElement | null>(null);

const inversePadding = computed(() => {
  if (!header.value) {
    return '0px';
  }

  const padding = getComputedStyle(header.value).getPropertyValue('--base-card-header-padding');
  if (!padding) {
    return '0px';
  }

  const paddingArray = padding.split(' ');
  const invertedPaddingArray = paddingArray.map((value) => {
    const unit = value.replace(/[0-9.]+/, '');
    const number = value.replace(/[^0-9.]+/, '');

    return `${Number(number) * -1}${unit}`;
  });

  return invertedPaddingArray.join(' ');
});

defineExpose({
  inversePadding,
});
</script>

<style>
.base-card .card-body > .bcc-header {
  margin: v-bind(inversePadding);
  margin-bottom: 1rem;
}
</style>
<style lang="scss" scoped>
.card-header {
  display: flex;
  align-items: center;
  flex: 1 0 0;
  padding: var(--base-card-header-padding);
}

.card-title {
  font-size: v-bind(fontSize);
  font-weight: v-bind(fontWeight);
  margin: 0;
}

.form-actions {
  display: flex;
  align-items: center;
  grid-column-gap: 1rem;
  margin-left: auto;

  > div {
    margin: 0 !important;
  }
}
</style>
